<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { Quill, quillEditor } from 'vue-quill-editor'
import { HtmlEditor, DocumentBlot, AudioBlot, PlainClipboard } from './QuiilSetting'
const Delta = Quill.import('delta')
import { mapGetters, mapState, mapActions } from "vuex"

Quill.register(AudioBlot);
Quill.register(DocumentBlot);
Quill.register('modules/htmlEditor', HtmlEditor)
Quill.register('modules/clipboard', PlainClipboard, true)

function convertImgToBase64URL(url, callback, outputFormat){
    let img = new Image()
    img.crossOrigin = 'Anonymous'
    img.onload = function(){
        let canvas = document.createElement('CANVAS'),
            ctx = canvas.getContext('2d'), dataURL;

        canvas.height = img.height
        canvas.width = img.width
        ctx.drawImage(img, 0, 0)
        dataURL = canvas.toDataURL(outputFormat)
        callback(dataURL)
        canvas = null
    }
    img.src = url
}

function dataURLtoFile(dataurl, filename) {

    let arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

    while(n--){
        u8arr[n] = bstr.charCodeAt(n)
    }

    return new File([u8arr], filename, {type:mime})
}

function b64toBlob(dataURI) {

    var byteString = atob(dataURI.split(',')[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);

    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: 'image/jpeg' });
}

const base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

// Создаем переменную таймера глобально
let searchId;
export default {
    data () {
        return {
            uploadPopupButton: false,
            filesPopup: false,
            editorOption: {
                modules: {
                    toolbar: '#toolbar',
                    htmlEditor: true
                },
                placeholder: this.$t('enter_text'),
                ops: []
            },
            submitHandler: 'news_columnist/postNews',
            textTest: '',
            disabled: false,
            addButtonText: this.$t('add'),
            popupTitle: this.$t('add_news'),
            finalyMessage: this.$t('news_created'),
            isLoading: {
                prep_levels: false,
                faculties: false,
                cathedras: false,
                education_programs: false,
                groups: false,
                roles: false,
                courses: false,
                profiles: false
            },
            uploadType: 'image',
            uploadPopupTitle: '',
            accept: '',
            newsPopup: false,
            selectActiveProfile: [],
            selectActive: {
                prep_levels: [],
                faculties: [],
                cathedras: [],
                education_programs: [],
                groups: [],
                courses: [],
                roles: []
            },
            news: {
                is_important: false,
                title: "",
                content: "",
                files: [],
                addressees: [],
                roles: [],
                courses: [],
                prep_levels: [],
                faculties: [],
                cathedras: [],
                education_programs: [],
                groups: [],
                image: ""
            }
        }
    },
    computed: {
        ...mapState({
            courses: state => state.news_columnist.courses,
            prep_levels: state => state.news_columnist.prep_levels,
            faculties: state => state.news_columnist.faculties,
            cathedras: state => state.news_columnist.cathedras,
            education_programs: state => state.news_columnist.education_programs,
            groups: state => state.news_columnist.groups,
            roles: state => state.news_columnist.roles,
            uploadSettings: state => state.news_columnist.formSetting,
            profiles: state => state.news_columnist.profiles
        }),
        editor () {
            return this.$refs.contentEditor.quill
        }
    },
    created() {
        // this.$store.dispatch('news_columnist/fetchFormSetting')
    },
    components: {
        quillEditor
    },
    methods: {
        async deleteNews() {
            // Удалем открытую новость
            try {
                this.$vs.loading({
                    container: '.delete_btn',
                    scale: 0.45
                })

                await this.$http.delete(`/portal/news/${ this.$route.params.uid }/`)

            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger'
                })
            } finally {
                this.$vs.loading.close('.delete_btn > .con-vs-loading')
                this.$router.push({name: 'newsIndex'})
            }
        },
        multiselectHander(selectedOption, id) {
            // Получаем список uid выбранных полей
            const getUids = () => {
                let uids = []
                if(this.selectActive[id].length) {
                    this.selectActive[id].forEach(item => {
                        uids.push(item.uid)
                    })
                }
                return uids
            }

            // Если выбрано факультет или кафедра, обновляем завясящие от них селекты
            if(id === 'faculties') {
                setTimeout(() => {
                    this.$store.commit('news_columnist/SET_ACTIVE', {key: id, value: getUids(), update_key: ['cathedras', 'groups']})
                }, 100);
            }
            if(id === 'cathedras') {
                setTimeout(() => {
                    this.$store.commit('news_columnist/SET_ACTIVE', {key: id, value: getUids(), update_key: ['groups']})
                }, 100);
            }
        },
        multiselectLabel(item) {

            // Заменяем лэйбл для поиска в селекте
            if(item.name) return item.name
            else {
                if(!isNaN(item)) return item
                else return this.$t(item)
            }
        },
        async removeFile({ file, done }){
            this.files = await this.files.filter(
                (item) => item.response.uid !== file.response.uid
            );
            done();
        },
        setFiles(response){
            // console.log('response', response)
            if (!this.files) this.files = [];
            // Преверяю, на то, чтобы, может прийти ответ с уже записанным в files файл
            if (
                this.files.indexOf(
                    (item) => item.name === response[0].name
                )
            ) {
                const firstFiles = this.files.filter(
                    (item) => item.firstFile || item.name !== response[0].name
                );
                const newFiles = response.map((item) => {
                    return {
                        ...item,
                        response: item,
                    };
                });
                this.files = firstFiles.concat(newFiles);
            } else {
                this.files = this.files.concat(
                    response.map((item) => {
                        return {
                            ...item,
                            response: item,
                        };
                    })
                );
            }
        },
        limitText (count) {
            // Если поле с профилями слишкой большое, ограничиваем показ профилей в поле и показываем это сообщение
            return `+ ${ count } ${ this.$t('profiles') }`
        },
        profileFind(query) {
            // Запрашиваем профили пользователей при вводе ФИО
            this.isLoading.profiles = true

            // Очищаем таймер
            clearTimeout(searchId);

            // Создаем таймер при завершении которого отправляем запрос к серверу
            searchId = setTimeout(async () => {
                try {
                    await this.$store.dispatch('news_columnist/profileFind', {fullname: query})
                } catch(error) {
                    this.$vs.notify({
                        text: error,
                        color: 'danger'
                    })
                } finally {
                    this.isLoading.profiles = false
                }
            }, 1000);
        },
        modalOpen() {
            // Если вызвали модалку для редактирования, подставляем данные текущей новости
            if(!this.modalType) {
                this.news = JSON.parse(JSON.stringify(this.$store.state.news.currentNews))
                this.submitHandler = 'news_columnist/putNews'
                this.finalyMessage = this.$t('news_updated')
                this.addButtonText = this.$t('update')
                this.popupTitle = this.$t('refresh_news')
                this.updateFormParams()

                if(this.news.front_image) {
                    // Вставляем изображение в форму загрузки
                    const find = this.files.find(file => file.uid === this.news.front_image.uid)
                    if(!find) {
                        this.files.push(
                            {
                                ...this.news.front_image,
                                firstFile: true,
                                response: this.news.front_image
                            }
                        )
                        /*
                        this.$nextTick(() => {
                            this.$refs['imageUpload'].setFiles()
                        })*/
                    }
                }
            }
            this.newsPopup = true
        },
        async updateFormParams() {
            const updateActive = (storeParams, key) => {
                let params = []
                this.news[key].forEach(item => {
                    params.push(storeParams[key].find(find => {
                        if(find.uid) return find.uid === item
                        else return find === item
                    }))
                    this.selectActive[key] = params
                })
            }

            // В цикле подставляем настройки видимости новости
            const storeParams = this.$store.state.news_columnist
            for(let key in this.selectActive) {
                if(this.news[key].length) {
                    if(!storeParams[key].length) {
                        await this.openSelect(key)
                        updateActive(storeParams, key)
                    } else {
                        updateActive(storeParams, key)
                    }
                }
            }

            if(this.news.persons.length)
                // Подставляем активные профили в селект ФИО Профиля
                this.selectActiveProfile = this.news.persons
        },
        formClear() {
            // Очищаем форму новости
            this.news = {
                is_important: false,
                title: "",
                content: "",
                files: [],
                addressees: [],
                roles: [],
                courses: [],
                prep_levels: [],
                faculties: [],
                cathedras: [],
                image: '',
                education_programs: [],
                groups: []
            }
            for (let key in this.selectActive) {
                this.selectActive[key] = []
            }

            this.$refs['imageUpload'].removeFile(0)

            this.selectActiveProfile = []
            this.$validator.reset();
            this.files = []
        },
        dynamicOptions(name) {
            // Так как поле настроек видимости выводиться в цикле, через эту функцию подставляем нужные данные в поле
            switch(name) {
                case 'prep_levels':
                    return this.prep_levels
                    break;
                case 'faculties':
                    return this.faculties
                    break;
                case 'cathedras':
                    return this.cathedras
                    break;
                case 'education_programs':
                    return this.education_programs
                    break;
                case 'groups':
                    return this.groups
                    break;
                case 'roles':
                    return this.roles
                    break;
                case 'courses':
                    return this.courses
                    break;
            }
        },
        async formSubmit() {
            // Валидация формы перед отправкой
            this.$validator.validateAll().then(async result => {
                if (result) {
                    if(this.selectActiveProfile.length) {
                        let addressees = []
                        this.selectActiveProfile.forEach(item => {
                            addressees.push(item.uid)
                        })
                        this.news['addressees'] = addressees
                    }

                    // Заполняем настройки видимости для новости
                    for (let key in this.selectActive) {
                        if(this.selectActive[key].length) {
                            let newArray = []

                            this.selectActive[key].forEach(item => {
                                if(item.uid) newArray.push(item.uid)
                                else newArray.push(item)
                            })

                            this.news[key] = newArray
                        } else {
                            this.news[key] = []
                        }
                    }

                    // Если есть изображение получаем ее uid
                    if(this.files.length)
                        this.news.image = this.files[0].uid
                    else
                        this.news.image = ''

                    try {
                        this.disabled = true
                        this.$vs.loading()

                        // Заполняем объект новости перед отправкой
                        let payload = {body: this.news}
                        // Если мы редактируем новость то получаем ее uid из адреса
                        if(!this.modalType)
                            payload['uid'] = this.$route.params.uid

                        // Отправляем запрос на создание/обновление новости
                        await this.$store.dispatch(this.submitHandler, payload)
                        this.$vs.notify({ text: this.finalyMessage, color:'success' })
                        this.formClear()

                        if(!this.modalType) {
                            this.newsPopup = false
                            this.$router.go(this.$router.currentRoute)
                        }
                    } catch(error) {
                        this.$vs.notify({ text: error, color:'danger' })
                    } finally {
                        this.disabled = false
                        this.$vs.loading.close()
                    }
                }
            })
        },
        filesModalHandler(type) {
            // Quill
            // Подставляем нужные настройки при выборе типа загрузки файла
            switch(type) {
                case 'image':
                    this.uploadPopupTitle = this.$t('upload_image')
                    this.uploadType = 'image'
                    this.accept = ".jpg, .jpeg, .png, .gif"
                    break;
                case 'video':
                    this.uploadPopupTitle = this.$t('upload_video')
                    this.uploadType = 'video'
                    this.accept = "video/*"
                    break;
                case 'audio':
                    this.uploadPopupTitle = this.$t('upload_audio')
                    this.uploadType = 'audio'
                    this.accept = "audio/*"
                    break;
                case 'doc':
                    this.uploadPopupTitle = this.$t('upload_document')
                    this.uploadType = 'doc'
                    this.accept = ".doc, .docx, .xlsx, .xls, .pdf"
                    break;
            }
            this.filesPopup = true
        },
        async handleFileUpload() {
            // Получаем файлы от поля загрузки
            const files = this.$refs.files.files;

            // Проверяем выбранное количество файлов для загрузки, если больше 5 то отменяем загрузку и выводм сообщение
            if(files.length > 5) {
                this.$vs.notify({
                    text: `За один раз можно загрузить максимум 5 файлов`,
                    color: 'warning'
                })
            }

            // Заполняем formData перед загрузкой файлов
            let formData = new FormData();
            for( var i = 0; i < files.length; i++ ){
                // Проверяем размер файла, если превышает выводим сообщение
                let maxFileSize = this.uploadSettings.max_file_size

                // Если это видео, ставим макс размер файла на 100 мб
                if(this.uploadType === 'video') maxFileSize = 100

                // Если это аудио, ставим макс размер файла на 50 мб
                if(this.uploadType === 'audio') maxFileSize = 50

                if (this.uploadSettings.max_file_size && ((files[i].size / 1024) / 1024) >= maxFileSize ){
                    this.$vs.notify({
                        text: `Файл ${ files[i].name } превышает ${ maxFileSize } мегабайт!`,
                        color: 'warning'
                    })
                    continue;
                }
                if(i > 4)
                    continue;
                formData.append('path', files[i])
            }

            // Если formData не пустая то продолжаем отправку
            if(formData.has('path')) {
                try {
                    this.$vs.loading({
                        background: 'primary',
                        color: '#fff',
                        container: '.files_input_button',
                        scale: 0.45
                    })
                    this.uploadPopupButton = true
                    // console.log(formData)
                    // Загружаем файлы на сервер
                    const {data} = await this.$http.post('common/upload/', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })

                    // Фокусируемся на quill для вставки файла
                    this.editor.focus()
                    let length = this.editor.getSelection().index;

                    // В цикле вставляем файлы в поле quill
                    data.forEach(file => {
                        if(this.uploadType === 'doc') this.editor.insertEmbed(length, this.uploadType, file)
                        else this.editor.insertEmbed(length, this.uploadType, file.path)
                    })

                    this.filesPopup = false
                    this.$vs.notify({ text: 'Файл добавлен', color:'success' })
                } catch(error) {
                    this.$vs.notify({ text: error, color:'danger' })
                } finally {
                    this.$vs.loading.close('.files_input_button > .con-vs-loading')
                    this.uploadPopupButton = false
                }
            }
        },
        async openSelect(type) {
            // События открытия выпадающего списка, при открытии либо запрашиваем данные для поля с сервера, либо получаем со стора ранее запрошенные данные
            try {
                // Включаем у селекта индикатор загрузки
                this.isLoading[type] = true
                await this.$store.dispatch('news_columnist/checkSelectType', type)
            } catch(e) {
                this.$vs.notify({
                    text: e,
                    color: 'danger'
                })
            } finally {
                // Отключаем у селекта индикатор загрузки
                this.isLoading[type] = false
            }
        },
    }
}
</script>
<style lang="scss">
.delete_btn{
    position: relative;
    .con-vs-loading{
        position: absolute;
    }
}
.ql-tooltip{
    &.ql-editing{
        &[data-mode="video"]{
            left: 10px!important;
            z-index: 50;
        }
    }
}
.news_modal{
    .vs-popup{
        width: 960px!important;
    }
    .quill-editor{
        .vs-icon{
            font-size: 18px;
        }
        #toolbar{
            position: sticky;
            top: -15px;
            z-index: 5555;
            background: #ffffff;
        }
        .ql-edit-html-textarea {
            width: 100%;
            background: rgb(29, 29, 29);
            color: rgb(204, 204, 204);
            outline: none;
            padding: 12px 15px;
            font-family: Consolas;
            position: absolute;
            top: 0;
            bottom: 0;
            border: none;
        }
    }
}
.upload_popup{
    z-index: 54000;
    .files_input{
        display: none;
    }
    .vs-popup{
        width: 400px!important;
    }
    .files_input_button{
        position: relative;
        overflow: hidden;
        .con-vs-loading{
            position: absolute;
        }
    }
}
.collapse_margin{
    background: #f8f8f8;
    .open-item{
        .vs-collapse-item--content{
            overflow: initial!important;
            max-height: initial!important;
        }
    }
}
</style>
